import { call, put, takeLatest } from 'redux-saga/effects';
import { Apis } from 'src/services/api';
import { addJobAsync, deleteJobAsync, getJobsAsync, updateJobAsync } from './actions';

function* getJobs(api, action) {
  try {
    const employees = yield call(api, action.payload);
    yield put(getJobsAsync.success(employees.data));
  } catch (err) {
    yield put(getJobsAsync.failure(err));
  }
}

function* updateJob(api, action) {
  try {
    const res = yield call(api, action.payload);
    if (res?.ok) yield put(updateJobAsync.success(res));
    else yield put(updateJobAsync.failure(res));
  } catch (err) {
    yield put(updateJobAsync.failure(err));
  }
}

function* addJob(api, action) {
  try {
    const res = yield call(api, action.payload);
    if (res?.ok) yield put(addJobAsync.success(res));
    else yield put(addJobAsync.failure(res));
  } catch (err) {
    yield put(addJobAsync.failure(err));
  }
}

function* deleteJob(api, action) {
  try {
    const response = yield call(api, action.payload);
    if (response?.ok) yield put(deleteJobAsync.success({}));
    else yield put(deleteJobAsync.failure(response));
  } catch (err) {
    yield put(deleteJobAsync.failure(err));
  }
}

export default function employeesSaga(apiInstance: Apis) {
  return [
    takeLatest(getJobsAsync.request, getJobs, apiInstance.getJobs),
    takeLatest(updateJobAsync.request, updateJob, apiInstance.updateJob),
    takeLatest(addJobAsync.request, addJob, apiInstance.addJob),
    takeLatest(deleteJobAsync.request, deleteJob, apiInstance.deleteJob),
  ];
}
